import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

// Custom imports
import installationSlice from "./Slices/InstallationSlice";
import defsSlice from "./Slices/DefsSlice";
import loggedInUserInfoSlice from "./Slices/LoggedInUserInfo";
import productSlice from "./Slices/ProductSlice";
import taskSlice from "./Slices/TaskSlice";
import assignmentSlice from "./Slices/AssignSlice";
import audioVideoSlice from "./Slices/AudioVideoSlice";
import assessSlice from "./Slices/AssessSlice";
import currentAssetSlice from "./Slices/CurrentAssetSlice";
import commonSlice from "./Slices/CommonSlice";
import currentILTActionsSlice from "./Slices/CurrentILTActions";

const reducers = combineReducers({
  installation: installationSlice.reducer,
  defs: defsSlice.reducer,
  loggedInUserInfo: loggedInUserInfoSlice.reducer,
  product: productSlice.reducer,
  task: taskSlice.reducer,
  assignment: assignmentSlice.reducer,
  audioVideo: audioVideoSlice.reducer,
  assess: assessSlice.reducer,
  currentAsset: currentAssetSlice.reducer,
  common: commonSlice.reducer,
  currentILTActions: currentILTActionsSlice.reducer
});

// Reset State of full Application
const rootReducer = (state, action) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }

  return reducers(state, action);
};

const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default Store;
